/**
 * @param {string} propValue
 * @returns - css value
 *
 * @example
 * createPropInlineStyle('100%', [2, 4]);
 */
var createPropInlineStyle = function createPropInlineStyle(propValue, exclude) {
  if (!propValue || exclude && exclude.includes(propValue) || typeof propValue !== 'string') {
    return undefined;
  }

  return propValue;
};

export default createPropInlineStyle;